import { DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { changes, fields } from "src/components/utils/fields";
import { QuoteFormField } from "./QuoteFormField";

export const QuoteInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation();

  const formFields = [
    { display: t("QuoteCode"), required: true, code: "quoteCode", type: "text" },
    { display: t("QuoteName"), required: true, code: "name", type: "text" },
    {
      display: t("Currency"),
      required: true,
      code: "currencyCode",
      type: "foreignKey",
      entity: "Currency",
      filterField: "code",
      labelFields: ["Code"],
      fields: [
        { key: "Code", value: "currencyCode" },
        { key: "Id", value: "CurrencyId" },
      ],
    },
    {
      display: t("Reference"),
      required: false,
      code: "reference",
      type: "text",
    },
    {
      display: t("Remarks"),
      required: false,
      code: "remarks",
      type: "textArea",
    },
  ];

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <DirectionsBoat style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("QuoteInfo")}
          </div>
        }
        elements={
          <div
            style={{
              display: "grid",
              // TODO: fix
              // gridTemplateColumns:
              //   (!matches15 && "auto") || (!matches11 && "auto auto") || "auto",
              justifyContent: "space-evenly",
            }}
          >
            {formFields.map((field, index) => <QuoteFormField fields={field} index={index} data={dataState} setData={setDataState} toggleable={dataState.isMultiEdit} />)}
            {/* {formFields.map((field, index) => {
              return fields(field, index, dataState, setDataState);
            })} */}
          </div>
        }
      />
    </>
  );
};
